export default __webpack_public_path__ + "static/media/NCLiechtenstein.03b48534.png";